import axios from "axios";
import { PROCESS_AUTOMATION_SERVICE_URL } from "../Common/Constant/API";
import { commonRequestHeaders } from "../Common/request/headers";

const migrationUrl = `${PROCESS_AUTOMATION_SERVICE_URL}/utils/github-migration`;

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
  "Content-Type": "application/json",
  ...commonRequestHeaders(),
});

export const getGitHubMigrationJobs = async () => {
  const response = await axios.get(`${migrationUrl}/jobs`, { headers: getHeaders() });
  return response.data || [];
};

export const getGitHubMigrationTenants = async () => {
  const response = await axios.get(`${migrationUrl}/github-tenants`, { headers: getHeaders() });
  return response.data || [];
};

export const validateGitHubMigration = async (request) => {
  const response = await axios.post(`${migrationUrl}/validate`, request, {
    headers: getHeaders(),
  });
  return response.data;
};

export const startGitHubMigrations = async (request) => {
  const response = await axios.post(`${migrationUrl}/start`, request, {
    headers: getHeaders(),
  });
  return response.data || [];
};

export const refreshGitHubMigrationJobs = async (credentials) => {
  const request = typeof credentials === "string" ? { githubPat: credentials } : credentials;
  const response = await axios.post(
    `${migrationUrl}/jobs/refresh`,
    request,
    { headers: getHeaders() }
  );
  return response.data || [];
};

export const cancelGitHubMigrationJob = async (jobId) => {
  const response = await axios.post(
    `${migrationUrl}/jobs/${jobId}/cancel`,
    {},
    { headers: getHeaders() }
  );
  return response.data;
};
